<template>
  <div class="cart-item">
    <b-row>
      <b-col
        cols="3"
        sm="2"
      >
        <b-img
          :src="`${rootUrl}${itemInfo.item_image_path}`"
          fluid
        />
      </b-col>
      <b-col
        cols="9"
        sm="9"
      >
        <router-link
          class="color-main"
          target="_blank"
          :to="{ name: 'home', query: { productId: itemInfo.offer_id } }"
        >
          <h2>{{ itemInfo.name }}</h2>
        </router-link>
        <div class="price">
          <p>السعر {{ itemInfo.selling_price }}</p>
          <div class="d-flex">
            <h4 class="text-secondary ml-3">
              الكمية:
            </h4>
            <div class="quantity d-flex">
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="plusQuantity"
              >
                <font
                  icon="plus"
                />
              </b-button>
              <span>{{ itemInfo.quantity }}</span>
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="minusQuantity"
              >
                <font
                  icon="minus"
                />
              </b-button>
            </div>
            <b-button
              size="sm"
              variant="outline-danger"
              class="mx-3"
              @click="removeFromCart(itemInfo.offer_id)"
            >
              <font icon="trash" />
              <span class="d-none d-md-inline-block mr-2">إزالة</span>
            </b-button>
          </div>
        </div>
      </b-col>
      <!-- <b-col cols="3" sm="2">
        <div class="quantaty">
          <p class="text-center">الكمية</p>
        </div>
      </b-col>
      <b-col cols="9" sm="9">
        <div class="quantaty">
            <VueNumericInput v-model="itemInfo.quantity"/>
        </div>
      </b-col> -->
    </b-row>
  </div>
</template>
<script type="text/javascript">
//import VueNumericInput from 'vue-numeric-input';
import {mapActions, mapMutations} from "vuex";
import {getStoreConfig} from "../../config";
const storeConfig = getStoreConfig();

export default {
  name: "CartItem",
  props: ["itemInfo"],
  //components:{VueNumericInput},
  data() {
    return {
      quan: 1,
      rootUrl: storeConfig.rootUrl,
    };
  },
  methods: {
    ...mapMutations(["setQuantity"]),
    ...mapActions(["removeFromCart", "addToCart"]),
    async plusQuantity() {
      const newQuantity = parseInt(this.itemInfo.quantity) + 1;
      const item = {
        name: this.itemInfo.name,
        first_offer_price: this.itemInfo.selling_price,
        id: this.itemInfo.offer_id,
        image_path: this.itemInfo.item_image_path,
      };

      await this.removeFromCart(item.id);
      this.addToCart({item, quantity: newQuantity});
    },
    async minusQuantity() {
      const newQuantity = parseInt(this.itemInfo.quantity) - 1;
      const item = {
        name: this.itemInfo.name,
        first_offer_price: this.itemInfo.selling_price,
        id: this.itemInfo.offer_id,
        image_path: this.itemInfo.item_image_path,
      };

      await this.removeFromCart(item.id);
      if (newQuantity > 0) {
        this.addToCart({item, quantity: newQuantity});
      }
    },
  },
};
</script>
